import { Skeleton } from "@mui/material";

export interface SprintStreakCardSkeletonProps {}

export function SprintStreakCardSkeleton({}: SprintStreakCardSkeletonProps) {
  return <Skeleton animation="wave" variant="rectangular" height={255} />;
}
